import * as React from "react";
const SvgFiRrTransformationBlock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-transformation-block_svg__a)">
      <path
        fill="#062147"
        d="M21.5 19c-.46 0-.886.133-1.256.35l-2.874-2.09A4 4 0 0 0 19 14.045l.011-4.087a4 4 0 0 0-1.636-3.221l2.868-2.086c.37.217.796.35 1.256.35a2.5 2.5 0 1 0-2.439-1.963l-3.563 2.591-1.502-.858a4.02 4.02 0 0 0-3.97 0l-1.515.865-3.573-2.599q.059-.26.061-.537A2.5 2.5 0 1 0 2.5 5c.46 0 .886-.133 1.256-.35l2.88 2.094a4 4 0 0 0-1.625 3.211L5 14.042c0 1.277.616 2.47 1.63 3.218l-2.874 2.09A2.5 2.5 0 0 0 2.5 19a2.5 2.5 0 1 0 2.439 1.963l3.568-2.595 1.508.862a4.004 4.004 0 0 0 3.969 0l1.508-.862 3.568 2.595A2.5 2.5 0 1 0 21.5 19M11.019 6.507a2 2 0 0 1 1.984 0l2.944 1.682L12 10.445 8.064 8.196zm-3.011 9.272A2 2 0 0 1 7 14.045l.011-4.087c0-.019.007-.038.008-.057L11 12.176v5.313zM13 17.488v-5.312l4.002-2.287c0 .023.009.044.009.066L17 14.042c0 .717-.386 1.382-1.008 1.737z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-transformation-block_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTransformationBlock;
